<template>
  <transition name="fadein">
    <div class="preview" v-show="show" @click="close">
      <svg-icon class="icon" icon-class="close" @click="close"></svg-icon>
      <div class="img-container">
        <img :src="url" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
  .icon {
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 30px;
    cursor: pointer;
    color: #999;
    &:hover {
      color: #fff;
    }
  }
  .img-container {
    margin: 100px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 1000px;
    }
  }
}
.fadein-enter,
.fadein-leave-to {
  opacity: 0;
  transform: scale(0);
}
.fadein-enter-active,
.fadein-leave-active {
  transition: all 0.2s ease;
}
</style>
